import { render, staticRenderFns } from "./ViewAssessment.vue?vue&type=template&id=a147a6b2&"
import script from "./ViewAssessment.vue?vue&type=script&lang=js&"
export * from "./ViewAssessment.vue?vue&type=script&lang=js&"
import style0 from "./ViewAssessment.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports